import React from "react";
import { editorTypes } from "../../../../util/circleHelper";
import ProfileIconCard from "../../../../components/ProfileIconCard/ProfileIconCard";
import css from './CreatePostForm.module.css'

const EditorOptionDropdown = (props) => {
    const { toggleDropdown, toggleInlineStyle, toggleBlockType, currentBlockType } = props
    const handleItemClick = (key) => {
        if (key === 'BOLD') {
            toggleInlineStyle(key)
        } else {
            toggleBlockType(key)
        }
        toggleDropdown()
    }
    return <div>
        <ul>
            {editorTypes.map((item) => <li key={item.key} onClick={() => handleItemClick(item.key)}
                className={currentBlockType === item.key ? css.selectedItem : css.unselectedItem}>

                <ProfileIconCard type={item.key} />
                {item.label}</li>)}
        </ul>
    </div>;
};

export default EditorOptionDropdown;